import { createSlice } from '@reduxjs/toolkit';



const initialState = {
  spinner: false,
  pagination: { page: 1 }
};

export const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    changeSpinner: (state, action) => {
      state.spinner = action.payload;
    },
    changeCurrentPage: (state, action) => {
      state.pagination = { ...state.pagination, page: action.payload };
    }
  }
});

export const { changeSpinner, changeCurrentPage } = appSlice.actions;
export default appSlice.reducer

